import React, { useState } from "react";
import Typography from "@mui/material/Typography";

export const TruncateText = ({ text, limit = 200 }) => {
    const [isExpanded, setisExpanded] = useState(false);
    const needsTruncated = text.length > limit;
    const txtShow = isExpanded || !needsTruncated
        ? text
        : `${text.substring(0, limit)}...`;

    return (
        <Typography
            variant="body2"
            component="div"
            sx={{
                fontSize: '0.875rem',
                lineHeight: '1.4',
                cursor: "pointer"
            }}
            onClick={() => needsTruncated && setisExpanded(!isExpanded)}
            dangerouslySetInnerHTML={{ __html: txtShow }}
        />
        // <Box>
        //     <Typography
        //         variant="body2"
        //         onClick={() => setEstaExpandido(!estaExpandido)}
        //         sx={{
        //             cursor: "pointer",
        //             fontSize: "0.875rem",
        //             lineHeight: "1.4",
        //             display: "-webkit-box",
        //             WebkitBoxOrient: "vertical",
        //             WebkitLineClamp: estaExpandido ? "none" : limit,
        //             overflow: "hidden",
        //             textOverflow: "ellipsis",
        //         }}
        //         dangerouslySetInnerHTML={{ __html: text }}
        //     />
        // </Box>
    );
};
